import styled from "styled-components";

export const SecondaryLabel = styled.span`
  color: #606060;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const SectionTitle = styled.span`
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

export const CounterValue = styled.span`
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;
// Layout Containers
export const MainContainer = styled.div`
  align-self: stretch;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 16px;
  padding-bottom: 16px;
  outline-offset: -1px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: flex;
`;

export const CyclesSection = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

export const VehicleSection = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
  position: relative;
`;

export const SectionHeader = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: inline-flex;
`;

export const SectionContent = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: inline-flex;
`;

// Counter Components
export const CounterContainer = styled.div`
  width: 200px;
  height: 40px;
  overflow: hidden;
  outline: 2px #d1d1d1 solid;
  outline-offset: -2px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  border-radius: 4px;
`;

export const CounterButton = styled.button`
  width: 56px;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  outline: 2px #d1d1d1 solid;
  outline-offset: -2px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: flex;
  background: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    background: #f4f4f4;
  }
`;

export const CounterInputContainer = styled.div`
  flex: 1 1 0;
  overflow: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  display: inline-flex;
`;

export const CounterInputSection = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

export const CounterInputField = styled.div`
  align-self: stretch;
  height: 40px;
  padding-left: 12px;
  padding-right: 12px;
  position: relative;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const CounterInputContent = styled.div`
  flex: 1 1 0;
  padding-left: 12px;
  padding-right: 12px;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const CounterValueContainer = styled.div`
  flex: 1 1 0;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const CounterOverlay = styled.div`
  width: 111px;
  height: 40px;
  left: 0px;
  top: 0px;
  position: absolute;
  opacity: 0.5;
  background: #e9e9e9;
`;

// Vehicle Dropdown Components
export const VehicleInputContainer = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  display: flex;
`;

export const VehicleInputSection = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
  position: relative;
`;

export const VehicleInputField = styled.div`
  align-self: stretch;
  height: 40px;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  display: inline-flex;
  border-radius: 4px;
  border: 1px solid #d1d1d1;
  background: white;
  cursor: pointer;

  &:hover {
    border-color: #a4a4a4;
  }
`;

export const VehicleInputContent = styled.div`
  flex: 1 1 0;
  padding-left: 12px;
  padding-right: 12px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

export const VehiclePlaceholder = styled.div`
  flex: 1 1 0;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
  display: flex;
`;

export const VehicleDropdownIcon = styled.div`
  width: 32px;
  height: 32px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const VehicleOverlay = styled.div`
  width: 100%;
  height: 40px;
  left: 0px;
  top: 0px;
  position: absolute;
  opacity: 0.5;
  background: #e9e9e9;
  border-radius: 4px;
`;

// Dropdown List Components
export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d1d1d1;
  border-radius: 4px;
  box-shadow: 0px 4px 12px rgba(27, 27, 27, 0.1);
  z-index: 1000;
  max-height: 280%;
  overflow-y: auto;
`;

export const DropdownItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;

  &:hover {
    background: #f4f4f4;
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

// Icon Containers
export const MinusIconContainer = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
`;

export const PlusIconContainer = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
`;
